export enum UrlParams {
    Action = 'action',
    RunTemplate = 'run-template',
    MatterId = 'matterId',
    AccountId = 'accountId',
    TemplateId = 'templateId',
    FileIds = 'fileIds',
    FolderIds = 'folderIds',
  }
  